import { render } from "./BoardingPlace.vue?vue&type=template&id=29652306&scoped=true"
import script from "./BoardingPlace.vue?vue&type=script&lang=js"
export * from "./BoardingPlace.vue?vue&type=script&lang=js"

import "./BoardingPlace.vue?vue&type=style&index=0&id=29652306&scoped=true&lang=css"

import exportComponent from "/var/www/intercity.dev-jatri.jatritech.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29652306"]])

export default __exports__